/* Atelier — accordion (product details, questions & answers). One item open at a time unless data-multiple is set.
   Markup: buttons [data-acc-toggle] with aria-expanded + aria-controls pointing at the panel. */
if (!customElements.get('atelier-accordion')) {
  customElements.define(
    'atelier-accordion',
    class AtelierAccordion extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.addEventListener('click', (event) => {
          const toggle = event.target.closest('[data-acc-toggle]');
          if (!toggle || toggle.closest('atelier-accordion') !== this) return;
          this.setOpen(toggle, toggle.getAttribute('aria-expanded') !== 'true');
        });
        // Theme editor: open the item whose block is selected.
        this.addEventListener('shopify:block:select', (event) => {
          const toggle = event.target.querySelector && event.target.querySelector('[data-acc-toggle]');
          if (toggle) this.setOpen(toggle, true);
        });
      }

      toggles() {
        return Array.from(this.querySelectorAll('[data-acc-toggle]')).filter((t) => t.closest('atelier-accordion') === this);
      }

      setOpen(toggle, open) {
        if (open && !this.hasAttribute('data-multiple')) {
          this.toggles().forEach((other) => {
            if (other !== toggle) this.apply(other, false);
          });
        }
        this.apply(toggle, open);
      }

      apply(toggle, open) {
        const was = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        const panel = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!panel) return;
        if (was === open && panel.hidden === !open) return;
        // open and close by height (and a soft fade), using the Web Animations API so no layout is measured mid-frame
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        // read where the panel is right now (mid-animation included) before cancelling, so a quick re-click
        // reverses from the current size instead of snapping
        const wasHidden = panel.hidden;
        const now = getComputedStyle(panel);
        const from = wasHidden ? 0 : panel.getBoundingClientRect().height;
        const mt = wasHidden ? '0px' : now.marginTop;
        const mb = wasHidden ? '0px' : now.marginBottom;
        if (panel._atAnim) panel._atAnim.cancel();
        if (reduce || typeof panel.animate !== 'function') {
          panel.hidden = !open;
          return;
        }
        panel.hidden = false;
        const to = open ? panel.scrollHeight : 0;
        // the panel's own margins animate with its height; otherwise they appear or vanish in one step at the
        // start of an open / end of a close, and everything below jumps
        const cs = getComputedStyle(panel);
        const mtTo = open ? cs.marginTop : '0px';
        const mbTo = open ? cs.marginBottom : '0px';
        panel.style.overflow = 'hidden';
        const anim = panel.animate(
          [
            { height: `${from}px`, marginTop: mt, marginBottom: mb, opacity: open ? 0 : 1 },
            { height: `${to}px`, marginTop: mtTo, marginBottom: mbTo, opacity: open ? 1 : 0 },
          ],
          // fill: forwards holds the last frame until the finish handler has hidden the panel; without it some
          // browsers (Safari) paint one frame of the closing panel at full height, then drop it, and the page jumps
          { duration: open ? 380 : 300, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)', fill: 'forwards' }
        );
        panel._atAnim = anim;
        anim.onfinish = () => {
          if (panel._atAnim !== anim) return;
          if (!open) panel.hidden = true;
          panel.style.overflow = '';
          anim.cancel();
          panel._atAnim = null;
        };
      }
    }
  );
}
